import { h } from 'preact';
import { ListEntry } from '@epx/flow';

const TASK_TYPES = ['epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask'];

// Values must match sfd XML (PascalCase — sfd stores the option "name" in XML)
const getOuterTypes = (i18n) => [
  { value: 'User', label: i18n['opt.User'] || 'User' },
  { value: 'Role', label: i18n['opt.Role'] || 'Role' },
  { value: 'Department', label: i18n['opt.Department'] || 'Department' },
];

// sfd uses text values from its API (e.g. "Company", "Department")
// Numeric levels 1-5 are also valid
const getRoleLevels = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Company', label: i18n['opt.Company'] || 'Company' },
  { value: 'Department', label: i18n['opt.Department'] || 'Department' },
  { value: 'Group', label: i18n['opt.Group'] || 'Group' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];

export class SfdPerformerPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const updatePerformers = (performers) => {
      lf.setProperties(id, { performers });
      lf.emit('node:properties-change', { id, properties: { performers } });
    };

    const performers = props.performers || [];

    const columns = [
      { key: 'name', label: i18n.name || 'Name', width: '28%' },
      { key: 'outerType', label: i18n.type || 'Type', type: 'select', options: getOuterTypes(i18n), width: '22%' },
      { key: 'outerId', label: i18n.id || 'ID', width: '12%' },
      { key: 'outerCode', label: i18n.code || 'Code', width: '18%' },
      { key: 'roleLevel', label: i18n.roleLevel || 'Role Level', type: 'select', options: getRoleLevels(i18n), width: '15%' },
    ];

    return [
      {
        id: 'performers',
        label: i18n.performers || 'Performers',
        badge: performers.length || undefined,
        entries: [
          {
            id: 'performersList',
            component: () => (
              <ListEntry
                id="sfd-performers"
                label=""
                items={performers}
                columns={columns}
                addLabel={i18n.addPerformer || '+ Add'}
                onAdd={() =>
                  updatePerformers([
                    ...performers,
                    { name: '', outerType: 'user', outerId: '', outerCode: '', roleLevel: '' },
                  ])
                }
                onRemove={(idx) => {
                  const updated = performers.filter((_, i) => i !== idx);
                  updatePerformers(updated);
                }}
                onChange={(idx, key, value) => {
                  const updated = performers.map((p, i) => (i === idx ? { ...p, [key]: value } : p));
                  updatePerformers(updated);
                }}
              />
            ),
          },
        ],
        isEdited: () => performers.length > 0,
      },
    ];
  }
}
